// import Vue from 'vue'
import { Component, Watch } from "vue-property-decorator";
import baseUserContextPage from "../baseUserContextPage";
import axios from "axios";
import domainService from "@/services/domainService";
import { categoryModel } from "@/models/categoryModel";
import { takeWhile } from "lodash";
import AppImage from "@/components/app-image.vue";
import { optionApplicabiliModel, optionDaApplicareModel } from "@/models/optionModel";

@Component({})
export default class filtriCategoriePage extends baseUserContextPage {
  showResetModal: boolean = false;
  visible: boolean = true;
  category: categoryModel = null;
  optionApplicabiliPerCategoria: optionDaApplicareModel[] = [];
  get options(): optionDaApplicareModel[] {
    var self = this;
    if (self.optionApplicabiliPerCategoria == null)
      return [];
    return self.optionApplicabiliPerCategoria.sort((a, b) => a.name > b.name ? 1 : -1);

  }
  get categoryId(): number {
    if (this.category == null)
      return null;
    return this.category.id;
  }
  categories: categoryModel[] = [];
  get categoriesSorted(): categoryModel[] {
    var self = this;
    if (self.categories == null)
      return [];
    else
      return self.categories.sort((a, b) => (a.displayOrder > b.displayOrder ? 1 : -1));
  }
  get title(): string {
    return this.category == null ? 'Catalogo' : this.getPropery(this.category, 'name');
  }
  getPropery(category: categoryModel, property: string) {
    if (category == null || category.locales == null) return "";
    var l = category.locales["it-IT"];
    return l == null ? "" : l[property];
  }
  fetch(): void {
    var self = this;
    self.setPageLoading(true);
    axios
      .get<Array<optionDaApplicareModel>>(`/configuration/filtri-applicabili/${self.categoryId == null ? '' : self.categoryId}`,)
      .then(res => {

        self.optionApplicabiliPerCategoria = res.data ? res.data.sort((a, b) => (a.name > b.name ? 1 : -1)) : [];

        self.setPageLoading(false);
      })
      .catch(error => {

        self.setPageLoading(false);
      });
  }

  created() {
    var instance = this;
    instance.category = null;
    domainService.getCategories().then(res => { (instance.categories = res == null ? [] : res); });
    instance.fetch();
  }
  mounted() {
    var instance = this;

    // instance.fetch();
  }
  onSelectCategory(category: categoryModel) {
    var self = this;
    self.category = category;
    self.fetch();

  }
  onSelezionaTutti(seleziona: boolean) {

    this.optionApplicabiliPerCategoria.forEach(x => x.active = seleziona);
  }
  onSalva() {
    var self = this;
    self.setPageLoading(true);
    axios
      .post<Array<optionDaApplicareModel>>(`/configuration/setta-filtri`, { filtri: self.optionApplicabiliPerCategoria })
      .then(res => {
        domainService.resetOptinFiltersForCategory(self.categoryId);
        self.fetch();
        self.$notify({
          title: "",
          text: "Configurazione salvata correttamente",
          type: "success",
          group: "msg"
        });
      })
      .catch(error => {

        // self.$notify({
        //   title: "",
        //   text: "Salvataggio non riuscito",
        //   type: "error",
        //   group: "msg"
        // });
        self.setPageLoading(false);
      });
  }

  onResetAllFilters() {
    var self = this;
    self.setPageLoading(true);
    axios
      .post<Array<optionDaApplicareModel>>(`/configuration/filtri/reset`)
      .then(res => {
        domainService.resetAllOptinFiltersForCategory();
        self.fetch();
        self.$notify({
          title: "",
          text: "Configurazione salvata correttamente",
          type: "success",
          group: "msg"
        });
      })
      .catch(error => {

        self.setPageLoading(false);
      }).finally(() => self.showResetModal = false);
  }

}